import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./offer-blocked.scss";
import {OfferProductSolutionType} from "../../../../../../models/offer/product/solution/OfferProductSolutionType";
import {CommunityPageBlogIconComponent} from "../../community/pages/site/icon/CommunityPageBlogIconComponent";
import {OfferService} from "../../../../../../services/offer/OfferService";
import {EntityService} from "../../../../../../services/entity/EntityService";
import {Resources} from "../../../../../../resources/Resources";
import {Network} from "../../../../../../network/Network";
import {OfferModalComponent} from "../modal/OfferModalComponent";
import {CommunityIndexationService} from "../../../../../../services/community/indexation/CommunityIndexationService";
import {
    CommunityPageIndexationRechargeModalComponent
} from "../../community/pages/tech/indexation/modal/CommunityPageIndexationRechargeModalComponent";
import {IOfferBlockedContent} from "./types/IOfferBlockedContent";

export class OfferBlockedComponent extends Component {

    private solutionType: OfferProductSolutionType;
    private closeModal: () => void;
    private content: IOfferBlockedContent;

    constructor(currentQuantity: number, limitQuantity: number, solutionType: OfferProductSolutionType, failureToPay: boolean, closeModal?: () => void, content?: IOfferBlockedContent) {
        super();
        this.solutionType = solutionType;
        this.closeModal = closeModal;
        this.content = content;
        //language=HTML
        this.template = `
            <div class="${s.componentOfferBlocked}">
                <div class="${s.title}">
                    ${this.title(solutionType)}
                </div>
                <div class="${s.description}">
                    ${this.description()}
                </div>
                <div class="${s.content}">
                    <div class="${s.title}">
                        ${this.nextStep()}
                    </div>
                    <div class="${s.entries}">
                        ${this.entries().map(entry => `
                            <div class="${s.entry}">
                                <div class="${s.icon}"></div>
                                ${entry}
                            </div>
                        `).join('')}
                    </div>
                    <div class="${s.illus}"></div>
                    <div class="${s.cases}">
                        ${EntityService.activeCommunity?.partnerType ? `
                        <div class="${s.case}">
                            <div class="${s.icon}">
                                ${this.draw(new CommunityPageBlogIconComponent(EntityService.activeCommunity?.partnerType))}
                            </div>
                        </div>
                        ` : ``}
                        <div class="${s.case}">
                            <div class="${s.icon} ${s.google}"></div>
                        </div>
                    </div>
                </div>
                ${OfferService.offerIsFree() ? `
                <div class="${s.reviewsContainer}">
                    ${Resources.t("words.offerBlockedLoveSedestral")}

                    <a class="${s.reviews}"
                       href="https://www.google.com/maps/place/Sedestral/@48.9330318,2.2512861,603m/data=!3m1!1e3!4m8!3m7!1s0x2c6cee227aff6493:0x5b77fd635342e640!8m2!3d48.9330283!4d2.253861!9m1!1b1!16s%2Fg%2F11y4y3cg6s?entry=ttu&g_ep=EgoyMDI1MTAxNC4wIKXMDSoASAFQAw%3D%3D">
                        <div class="${s.trust}"></div>
                        <div class="${s.view}">
                            <div class="${s.icon}"></div>
                            <div>
                                ${Resources.t("words.see")}
                            </div>
                        </div>
                    </a>
                </div>
                ` : ``}
                <div class="${s.buttons}">
                    <div class="${s.button}">
                        ${this.isCredits() ? Resources.t("words.offerBlockedRechargeCredits") : (EntityService.activeOfferIsFailureToPay ? Resources.t("words.offerBlockedResolvePayment") : Resources.t("words.offerBlockedViewOffers"))}
                        <div class="${s.arrow}"></div>
                    </div>
                    ${this.isCredits() ? `` : `
                    <div class="${s.text}">
                        ${EntityService.activeOfferIsFailureToPay ? Resources.t("words.offerBlockedPaymentHelp") : Resources.t("words.offerBlockedNoCommitment")}
                    </div>
                    `}
                </div>
            </div>
        `;
    }

    commit() {
        this.el(s.button).onClick(async () => {
            if (this.isCredits()) {
                const community = EntityService.activeCommunity;
                const overview = await CommunityIndexationService.getOverview(community.id, this);
                if (overview != undefined) {
                    new CommunityPageIndexationRechargeModalComponent(community, overview, () => {
                    }).screenRender();
                    if (this.closeModal != undefined) {
                        this.closeModal();
                    }
                }
            } else if (EntityService.activeOfferIsFailureToPay) {
                await Network.router.pages.redirect("/b/home/content/subscriptions/home");
                location.reload();
            } else {
                let offerModal = new OfferModalComponent();
                offerModal.screenRender();
            }
        });

        super.scrollable();
        super.commit();
    }

    public isCredits(): boolean {
        return this.solutionType == OfferProductSolutionType.INDEXATION;
    }

    public title(solutionType: OfferProductSolutionType): string {
        if (this.isCredits()) {
            return Resources.t("words.offerBlockedIndexationTitle");
        }
        if (EntityService.activeOfferIsFailureToPay) {
            return Resources.t("words.offerBlockedPaymentFailedTitle");
        }
        if (this.content?.title != undefined) {
            return this.content.title;
        }

        const isFree = OfferService.offerIsFree();

        switch (solutionType) {
            case OfferProductSolutionType.AI_CONTENT:
                return isFree ? Resources.t("words.offerBlockedTrialArticleCreated") : Resources.t("words.offerBlockedArticleQuotaExhausted");
            case OfferProductSolutionType.WRITING_STYLE:
                return Resources.t("words.offerBlockedFeatureUnavailable");
            case OfferProductSolutionType.SEO_CLUSTER:
                return isFree ? Resources.t("words.offerBlockedTrialClusterCreated") : Resources.t("words.offerBlockedClusterQuotaExhausted");
            case OfferProductSolutionType.SEO_AUDIT:
                return isFree ? Resources.t("words.offerBlockedTrialAuditDone") : Resources.t("words.offerBlockedAuditQuotaExhausted");
            case OfferProductSolutionType.OPTIMIZATION_CONTENT:
            case OfferProductSolutionType.OPTIMIZATION_PRODUCTS_OR_CATEGORIES:
                return isFree ? Resources.t("words.offerBlockedTrialOptimizationUsed") : Resources.t("words.offerBlockedOptimizationQuotaExhausted");
            case OfferProductSolutionType.BRIEF_CONTENT:
                return isFree ? Resources.t("words.offerBlockedTrialBriefCreated") : Resources.t("words.offerBlockedBriefQuotaExhausted");
            case OfferProductSolutionType.SEO_PAGE_TRACKING:
                return isFree ? Resources.t("words.offerBlockedTrialQuotaExhausted") : Resources.t("words.offerBlockedPageTrackingQuotaExhausted");
            case OfferProductSolutionType.SEO_SEARCH_KEYWORDS:
                return Resources.t("words.offerBlockedKeywordSearchQuotaExhausted");
            case OfferProductSolutionType.SEO_COMPETITORS_ANALYZE:
                return Resources.t("words.offerBlockedCompetitorAnalyzeQuotaExhausted");
            case OfferProductSolutionType.IMAGES_ALT_GENERATION:
                return isFree ? Resources.t("words.offerBlockedTrialImageAltUsed") : Resources.t("words.offerBlockedImageAltQuotaExhausted");
            case OfferProductSolutionType.IMAGES_OPTIMIZATION:
                return isFree ? Resources.t("words.offerBlockedTrialImageOptimizationUsed") : Resources.t("words.offerBlockedImageOptimizationQuotaExhausted");
            case OfferProductSolutionType.COMMUNITY:
                return isFree ? Resources.t("words.offerBlockedTrialSiteCreated") : Resources.t("words.offerBlockedSiteOrLanguageQuotaExhausted");
            case OfferProductSolutionType.LLM_PROMPTS:
                return Resources.t("words.offerBlockedLlmPromptsQuotaExhausted");
            case OfferProductSolutionType.USERS:
                return Resources.t("words.offerBlockedUsersQuotaExhausted");
            default:
                return isFree ? Resources.t("words.offerBlockedTrialUsed") : Resources.t("words.offerBlockedGeneralQuotaExhausted");
        }
    }

    public description(): string {
        if (this.isCredits()) {
            return Resources.t("words.offerBlockedIndexationDescription");
        }
        if (EntityService.activeOfferIsFailureToPay) {
            return Resources.t("words.offerBlockedPaymentFailedDescription");
        }
        if (this.content?.description != undefined) {
            return this.content.description;
        }

        const isEssentiel = OfferService.offerIsEssentiel();
        const isPro = OfferService.offerIsPro();
        const isMax = OfferService.offerIsMax();
        const isEnterprise = OfferService.offerIsEnterprise();

        if (isEssentiel || isPro || isMax) {
            return Resources.t("words.offerBlockedDescriptionUpgrade");
        } else if (isEnterprise) {
            return Resources.t("words.offerBlockedDescriptionEnterprise");
        }

        return Resources.t("words.offerBlockedDescriptionFree");
    }

    public nextStep(): string {
        if (this.isCredits()) {
            return Resources.t("words.offerBlockedIndexationNextStep");
        }
        if (EntityService.activeOfferIsFailureToPay) {
            return Resources.t("words.offerBlockedPaymentFailedNextStep");
        }
        if (this.content?.nextStep != undefined) {
            return this.content.nextStep;
        }

        const isEssentiel = OfferService.offerIsEssentiel();
        const isPro = OfferService.offerIsPro();
        const isMax = OfferService.offerIsMax();
        const isEnterprise = OfferService.offerIsEnterprise();

        if (isEssentiel) {
            return Resources.t("words.offerBlockedNextStepEssentiel");
        } else if (isPro) {
            return Resources.t("words.offerBlockedNextStepPro");
        } else if (isMax) {
            return Resources.t("words.offerBlockedNextStepMax");
        } else if (isEnterprise) {
            return Resources.t("words.offerBlockedNextStepEnterprise");
        }

        return Resources.t("words.offerBlockedNextStepFree");
    }

    public entries(): string[] {
        if (this.isCredits()) {
            return [
                Resources.t("words.offerBlockedIndexationEntry1"),
                Resources.t("words.offerBlockedIndexationEntry2"),
                Resources.t("words.offerBlockedIndexationEntry3")
            ];
        }
        if (EntityService.activeOfferIsFailureToPay) {
            return [
                Resources.t("words.offerBlockedPaymentEntry1"),
                Resources.t("words.offerBlockedPaymentEntry2"),
                Resources.t("words.offerBlockedPaymentEntry3")
            ];
        }
        if (this.content?.entries != undefined) {
            return this.content.entries;
        }

        const isEssentiel = OfferService.offerIsEssentiel();
        const isPro = OfferService.offerIsPro();
        const isMax = OfferService.offerIsMax();
        const isEnterprise = OfferService.offerIsEnterprise();

        if (isEssentiel) {
            return [
                Resources.t("words.offerBlockedEntryAddOneSiteOrLanguage"),
                Resources.a("words.offerBlockedEntryCreate3xMoreArticles"),
                Resources.a("words.offerBlockedEntryOptimize3xMorePages"),
                Resources.t("words.offerBlockedEntryIncreaseLimits3x"),
                Resources.a("words.offerBlockedEntryAnalyzeCompetitors"),
                Resources.a("words.offerBlockedEntryAnalyzeTechnicalQuality")
            ];
        }

        if (isPro) {
            return [
                Resources.t("words.offerBlockedEntryAddSixSitesOrLanguages"),
                Resources.a("words.offerBlockedEntryCreate3xMoreArticles"),
                Resources.a("words.offerBlockedEntryOptimize3xMorePages"),
                Resources.t("words.offerBlockedEntryIncreaseLimits3x"),
                Resources.a("words.offerBlockedEntryAnalyzeCompetitors"),
                Resources.a("words.offerBlockedEntryAnalyzeTechnicalQuality")
            ];
        }

        if (isMax) {
            return [
                Resources.t("words.offerBlockedEntryPersonalizedSupport"),
                Resources.t("words.offerBlockedEntryAddTwoSitesOrLanguages"),
                Resources.a("words.offerBlockedEntryCreate3xMoreArticles"),
                Resources.a("words.offerBlockedEntryOptimize3xMorePages"),
                Resources.t("words.offerBlockedEntryIncreaseLimits3x")
            ];
        }

        if (isEnterprise) {
            return [
                Resources.t("words.offerBlockedEntryAdjustQuotas"),
                Resources.t("words.offerBlockedEntryAddUpTo100Sites"),
                Resources.a("words.offerBlockedEntryOptimize300xMorePages"),
                Resources.t("words.offerBlockedEntryAdjustAllLimits")
            ];
        }

        return [
            Resources.t("words.offerBlockedEntryFreeIntro"),
            Resources.a("words.offerBlockedEntryCreateOptimizedArticles"),
            Resources.a("words.offerBlockedEntryPublishAutomatically"),
            Resources.a("words.offerBlockedEntryOptimizeProductPages"),
            Resources.a("words.offerBlockedEntryBuildSemanticClusters")
        ];
    }

}